import React, { useState } from "react";
import Link from "next/link";

import Button from "@core/design-system/button";
import Popper from "@mui/material/Popper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { ArrowPopper, PopperContent } from "./styles";

import { NewsFeatureBadge } from "@mais-retorno-front/components/new-feature-badge";
import { DEFAULT_ROUTES } from "@mais-retorno-front/constants/routes";

export const CtaComparisson = () => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setOpen(true);
  }

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(null);
    setOpen(false);
  }
  return (
    <>
      <Button
        aria-describedby="comparison-popper"
        variant="outlined"
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        component="a"
        href={DEFAULT_ROUTES.assetsComparison}
        LinkComponent={Link}
      >
        Comparador de ativos
      </Button>

      <Popper
        id="comparison-popper"
        placement="bottom-start"
        open={open}
        anchorEl={anchorEl}
      >

        <PopperContent>
          <ArrowPopper />

          <Box ml={1}>
            <NewsFeatureBadge />
          </Box>

          <Typography
            variant="h6"
            fontWeight="700"
          >
            Compare ativos, stocks e FIIs!
          </Typography>
          <Typography variant="body2">
            Compare diversos tipos de ativos com benchmarks e outros indicadores
            exclusivos!
          </Typography>
        </PopperContent>
      </Popper>
    </>

  )
}